import React from 'react';

import logo from '../assets/images/logo.svg';

const Header = (props) => (
	<header id="header" className="alt">
		<h1> happily ever after</h1>
	</header>
);

export default Header;
